import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const hotArticles = articles.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              最新热点资讯
            </h2>
          </div>
          <Link
            to="/category/remenzixun"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-white text-xs rounded-full whitespace-nowrap">
                    {article.category === 'remenzixun' ? '热门' : article.category === 'chigua' ? '吃瓜' : '资讯'}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 mb-2 leading-relaxed group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views > 10000
                      ? `${(article.views / 10000).toFixed(1)}万`
                      : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}